import type LoggerService from '@app/service/logger.service';
import { HTTP_ERROR_STATUSES_SKIP_LOGGING } from './http-error.constants';

export default function initializeHttpErrorInterceptor(app: angular.IModule) {
  app.factory('httpErrorInterceptor', [
    '$q',
    'loggerService',
    'IS_TEST',
    ($q: angular.IQService, loggerService: LoggerService, IS_TEST: boolean) => ({
      responseError: (response: angular.IHttpResponse<any>) => {
        if (!IS_TEST && !HTTP_ERROR_STATUSES_SKIP_LOGGING.includes(response.status)) {
          loggerService.error('HTTP Error', {
            status: response.status,
            url: response.config?.url,
            method: response.config?.method,
            data: response.data
          });
        }
        return $q.reject(response);
      }
    })
  ]);

  app.config([
    '$httpProvider',
    ($httpProvider: angular.IHttpProvider) => {
      $httpProvider.interceptors.push('httpErrorInterceptor');
    }
  ]);
}
